import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export const ExamLandingSection = ({
  children,
  black = false,
  backgroundSrc,
}: {
  children: ReactNode;
  black?: boolean;
  backgroundSrc?: string;
}) => {
  return (
    <div
      className={cn(
        `mx-auto flex flex-col items-center justify-center gap-[80px] bg-white bg-cover bg-center py-[128px]`,
        black && "bg-black",
      )}
      style={{
        backgroundImage: backgroundSrc
          ? `url(https://cdn.remedium.md/${backgroundSrc})`
          : undefined,
      }}
    >
      {children}
    </div>
  );
};
